import React, { Fragment } from 'react';
import Scroll from 'react-scroll';
import icMail from '../../assets/information/ic-mail.svg';
import icTel from '../../assets/information/ic-tel.svg';
import icLoc from '../../assets/information/ic-loc.svg';
import Animate from '../Animate';

const Element = Scroll.Element;

const Information = ({ t }) => (
    <Fragment>
        <div id="information" className="landing-container-information">
            <div className="landing-layout">
                <div className="landing-page-information">
                    <div className="landing-basic-header">
                        <Animate>
                            <h2 className="landing-section-title">{t("landing.information.title")}</h2>
                        </Animate>
                        <p className="landing-section-text">{t("landing.information.subtitle")}</p>
                    </div>
                    <Element name="scrollToContact" />
                    <div className="landing-basic-kontakt">
                        <h3>{t("landing.information.contakt")}</h3>
                        <div className="landing-basic-kontakt-elements">
                            <img
                                src={icMail}
                                alt=""
                            />
                            <p>{t("landing.information.email")}</p>
                        </div>
                        <div className="landing-basic-kontakt-elements">
                            <img
                                src={icTel} alt=""
                            />
                            <span>
                                <p>{t("landing.information.phone")}</p>
                                <p>{t("landing.information.fax")}</p>
                            </span>
                        </div>
                        <h3>{t("landing.information.address")}</h3>
                        <div className="landing-basic-kontakt-elements">
                            <img
                                src={icLoc} alt=""
                            />
                            <span className="landing-basic-kontakt-elements-details">
                                <p>{t("landing.information.name")}</p>
                                <p>{t("landing.information.adress")}</p>
                                <p>{t("landing.information.adress_street")}</p>
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </Fragment>

);

export default Information;
